import { Flex } from '@zillow/constellation';
import { Select } from '@zillow/constellation';
import { Input } from '@zillow/constellation';
import { Box } from '@zillow/constellation';
import { FormField } from '@zillow/constellation';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { sentInErrorReasonOptions } from 'types/accounting/eVoidReason';
import { ISelectOption } from '../../../../../../ui-toolkit';

interface IVoidReasonProps {
  reasonList: ISelectOption<string>[];
}

export const VoidReason: React.FC<IVoidReasonProps> = ({ reasonList }) => {
  return (
    <Field name="voidReason">
      {({ field }: FieldProps<string>) => (
        <Flex display={'flex'} gap={1}>
          <Box sx={{ flexBasis: field.value === 'Other' ? '30%' : 'auto' }}>
            <FormField
              label="Void Reason*"
              required
              control={
                <Select {...field}>
                  <option value="">Select a reason...</option>
                  {reasonList.map((item) => (
                    <option value={item.value} key={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Select>
              }
            />
          </Box>
          {field.value === 'Other' && (
            <Field name="voidReasonDescription">
              {({ field }: FieldProps<string>) => (
                <Box sx={{ flexGrow: '1' }}>
                  <FormField
                    label="Other Void Reason*"
                    required
                    control={<Input fluid {...field} placeholder="Other Void Reason" />}
                  />
                </Box>
              )}
            </Field>
          )}
          {field.value === 'Sent in Error' && (
            <Field name="voidReasonDescription">
              {({ field }: FieldProps<string>) => (
                <Box sx={{ flexGrow: '1' }}>
                  <FormField
                    label="Sent in Error Reason*"
                    required
                    control={
                      <Select {...field}>
                        <option value="">Select a reason...</option>
                        {sentInErrorReasonOptions.map((item) => (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </Select>
                    }
                  />
                </Box>
              )}
            </Field>
          )}
        </Flex>
      )}
    </Field>
  );
};
